import ENV from "@/utils/env";

/*
 * getThumbnailImage function
 *
 * This function generates a URL for fetching a thumbnail image from the renderer.
 */
export const getThumbnailImage = (key: string, width: number, height: number, projectId: string, studyId: string) => {
  return `${ENV.API_PLATFORM_URL}/pipeline/renderer/v1/images?prefix=${projectId}/${studyId}&key=${key}&maxHeight=${height}&maxWidth=${width}`;
};
